import { render, staticRenderFns } from "./AliyunCaptcha.vue?vue&type=template&id=7632a3bd&"
import script from "./AliyunCaptcha.vue?vue&type=script&lang=js&"
export * from "./AliyunCaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports